import React from 'react';
import { useIntl } from 'react-intl';
import { Input } from '..';
import { cprRegex } from '../../../helpers/regex';

interface ICprInputProps {
    name: string;
    value?: string;
    disabled?: boolean;
    required?: boolean;
    placeholder?: string;
    className?: string;
    mask?: string;
    touched?: boolean;
    externalUpdateValue?: string;
    ariaLabel?: string;
    ariaLabelledBy?: string;
    regex?: RegExp;
    maxLength?: number;
    onChange?: (event: React.FormEvent, isValid: boolean) => void;
    errorHandler?: (value: string) => string;
    checkShownErrors?: (name: string, errorMessage: string) => void;
}

export const CprInput = (props: ICprInputProps): JSX.Element => {
    const { formatMessage } = useIntl();

    const errorHandler = (value: string): string => {
        value = props.mask ? value.replace(/ /g, '') : value;

        if (value.match('^[-]+$') !== null) {
            return '';
        }

        if (value && value.match(props.regex ? props.regex : cprRegex) === null) {
            return formatMessage({ id: 'ASKCPR_ERROR_INVALID_CPR' });
        } else if (props.errorHandler) {
            return props.errorHandler(value);
        }

        return '';
    };

    return (
        <Input maskChar={props.mask ? '-' : ''} {...props} errorHandler={errorHandler} maxLength={props.maxLength} />
    );
};
